module.exports = __webpack_public_path__ + "img/linkedin_snippet.8ee1e40c.svg";